import { User } from "@/core/services/api/interfaces/manager/User";

export class LiveChatSettings {
  constructor(
    public user_id: undefined | null | number,
    public token: undefined | null | string,
    public name: undefined | null | string,
    public email: undefined | null | string,
    public company_id: undefined | null | number
  ) {}

  public static fromJson(json: {
    user_id: number | null | undefined;
    token: string | null | undefined;
    name: string | null | undefined;
    email: string | null | undefined;
    company_id: number | null | undefined;
  }): LiveChatSettings {
    return new LiveChatSettings(
      json.user_id,
      json.token,
      json.name,
      json.email,
      json.company_id
    );
  }

  public static fromUser(user?: User): LiveChatSettings {
    return this.fromJson({
      user_id: user?.id,
      token: user?.livechat_token,
      name: user?.first_name,
      email: user?.email,
      company_id: user?.company?.id,
    });
  }
}
